"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.annotation = void 0;

var _region = require("./region");

var _DisplayColorType = require("../../../types/DisplayColorType");

var _types = require("../../../types");

var annotation = {
  // Attributes:
  id: {
    type: Number,
    path: '$.Id'
  },
  type: {
    type: Number,
    path: '$.Type'
  },
  name: {
    type: String,
    path: '$.Name'
  },
  isSelected: {
    type: _types.BooleanAsNumber,
    path: '$.Selected'
  },
  isReadOnly: {
    type: _types.BooleanAsNumber,
    path: '$.ReadOnly'
  },
  isNameReadOnly: {
    type: _types.BooleanAsNumber,
    path: '$.NameReadOnly'
  },
  isLineColorReadOnly: {
    type: _types.BooleanAsNumber,
    path: '$.LineColorReadOnly'
  },
  isIncremental: {
    type: _types.BooleanAsNumber,
    path: '$.Incremental'
  },
  lineColor: {
    type: Number,
    path: '$.LineColor'
  },
  isVisible: {
    type: _types.BooleanAsNumber,
    path: '$.Visible'
  },
  macroName: {
    type: String,
    path: '$.MacroName'
  },
  // Children
  imageId: {
    type: Number,
    path: 'ImageId'
  },
  macroId: {
    type: Number,
    path: 'MacroId'
  },
  inputAnnotationId: {
    type: Number,
    path: 'InputAnnotationId'
  },
  attributes: {
    path: 'Attributes[0].Attribute',
    model: {
      // Attributes
      id: {
        type: Number,
        path: '$.Id'
      },
      name: {
        type: String,
        path: '$.Name'
      },
      value: {
        type: String,
        path: '$.Value'
      },
      displayColor: {
        type: _DisplayColorType.DisplayColorType,
        path: '$.DisplayColor'
      },
      // Children
      globalId: {
        type: String,
        path: 'GlobalId'
      }
    }
  },
  regions: _region.createRegions
};
exports.annotation = annotation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/annotations/response-parsers/layer.js
// module id = 233
// module chunks = 0